module.exports = __webpack_public_path__ + "static/img/contant_3.7ae844f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_4/contant_3.jpg
// module id = znS8
// module chunks = 0